import React from 'react'
import styled from 'styled-components'
import LayoutContent from '@components/LayoutContent'
import MapSunsetSVG from '@components/MapSunsetSVG'
import { compose, withTranslation, hoistStatics } from '@hocs'
import { withRNApp } from '@libs/RNApp'

type TProps = {
  isApp: boolean
  t: any
}
const Goodbye: React.FC<TProps> = (props) => {
  const { isApp, t } = props
  return (
    <LayoutContent isApp={isApp}>
      <Section>
        <Text>{t(['sunset'])}</Text>
        <MapSunsetSVG />
      </Section>
    </LayoutContent>
  )
}

export default compose(withRNApp, hoistStatics(withTranslation(['map'])))(Goodbye)

const Section = styled.section`
  width: 384px;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
  @media only screen and (max-width: 400px) {
    width: 100%;
    padding: 24px 15px;
  }
  > svg {
    position: relative;
    max-width: 100%;
    height: auto;
  }
`
const Text = styled.p`
  font-size: 14px;
  line-height: 20px;
  width: 240px;
  text-align: center;
  font-weight: 400;
  margin-bottom: 60px;
`
